const queryParamMap = new Map<string, string>();

export const useContextParameters = () => {
  const addParam = (
    param:
      | 'bedarfId'
      | 'angebotId'
      | 'bestandsvertragId'
      | 'clientId'
      | 'gdvContractId'
      | 'gdvContractVnId'
      | 'profileId',
    value: string,
  ) => {
    queryParamMap.set(param, value);
  };

  const getParams = () => Object.fromEntries(queryParamMap);

  return {
    addParam,
    getParams,
    queryParamMap,
  };
};
